import { EventCatalogFromKeys, EventType } from "../types";

export const LayoutEventKeys = {
  BREADCRUMB_NAV_CLICK: "breadcrumb-nav-click",
  LOGOUT_ATTEMPT: "logout-attempt",
  PUBLIC_FOOTER_LINK_CLICK: "public-footer-link-click",
  PUBLIC_HEADER_CTA_GET_STARTED_CLICK: "public-header-cta-get-started-click",
  PUBLIC_HEADER_CTA_SIGNIN_CLICK: "public-header-cta-signin-click",
  PUBLIC_HEADER_MOBILE_MENU_TOGGLE: "public-header-mobile-menu-toggle",
  PUBLIC_HEADER_NAV_LINK_CLICK: "public-header-nav-link-click",
} as const;

export const LayoutEventCatalog: EventCatalogFromKeys<typeof LayoutEventKeys> =
  {
    [LayoutEventKeys.PUBLIC_FOOTER_LINK_CLICK]: {
      description: "User clicked a link in the public footer",
      eventType: EventType.BUTTON_CLICK,
      id: LayoutEventKeys.PUBLIC_FOOTER_LINK_CLICK,
    },
    [LayoutEventKeys.LOGOUT_ATTEMPT]: {
      description: "User attempted to log out",
      eventType: EventType.INTERACTION,
      id: LayoutEventKeys.LOGOUT_ATTEMPT,
    },
    [LayoutEventKeys.PUBLIC_HEADER_NAV_LINK_CLICK]: {
      description: "User clicked a navigation link in the public header",
      eventType: EventType.BUTTON_CLICK,
      id: LayoutEventKeys.PUBLIC_HEADER_NAV_LINK_CLICK,
    },
    [LayoutEventKeys.PUBLIC_HEADER_CTA_SIGNIN_CLICK]: {
      description: "User clicked the Sign In CTA button in the public header",
      eventType: EventType.BUTTON_CLICK,
      id: LayoutEventKeys.PUBLIC_HEADER_CTA_SIGNIN_CLICK,
    },
    [LayoutEventKeys.PUBLIC_HEADER_CTA_GET_STARTED_CLICK]: {
      description:
        "User clicked the Get Started CTA button in the public header",
      eventType: EventType.BUTTON_CLICK,
      id: LayoutEventKeys.PUBLIC_HEADER_CTA_GET_STARTED_CLICK,
    },
    [LayoutEventKeys.PUBLIC_HEADER_MOBILE_MENU_TOGGLE]: {
      description: "User toggled the mobile menu in the public header",
      eventType: EventType.INTERACTION,
      id: LayoutEventKeys.PUBLIC_HEADER_MOBILE_MENU_TOGGLE,
    },
    [LayoutEventKeys.BREADCRUMB_NAV_CLICK]: {
      description:
        "User clicked a breadcrumb navigation link in PageBreadcrumbs",
      eventType: EventType.BUTTON_CLICK,
      id: LayoutEventKeys.BREADCRUMB_NAV_CLICK,
    },
  };
